// feature
export { default as ColumnDrag } from '../lib/TaskBoard/feature/ColumnDrag.js';
export { default as ColumnHeaderMenu } from '../lib/TaskBoard/feature/ColumnHeaderMenu.js';
export { default as ColumnToolbars } from '../lib/TaskBoard/feature/ColumnToolbars.js';
export { default as SimpleTaskEdit } from '../lib/TaskBoard/feature/SimpleTaskEdit.js';
export { default as SwimlaneDrag } from '../lib/TaskBoard/feature/SwimlaneDrag.js';
export { default as TaskBoardFeature } from '../lib/TaskBoard/feature/TaskBoardFeature.js';
export { default as TaskDrag } from '../lib/TaskBoard/feature/TaskDrag.js';
export { default as TaskDragSelect } from '../lib/TaskBoard/feature/TaskDragSelect.js';
export { default as TaskEdit } from '../lib/TaskBoard/feature/TaskEdit.js';
export { default as TaskMenu } from '../lib/TaskBoard/feature/TaskMenu.js';
export { default as TaskTooltip } from '../lib/TaskBoard/feature/TaskTooltip.js';
// model
export { default as ColumnModel } from '../lib/TaskBoard/model/ColumnModel.js';
export { default as ProjectModel } from '../lib/TaskBoard/model/ProjectModel.js';
export { default as SwimlaneModel } from '../lib/TaskBoard/model/SwimlaneModel.js';
export { default as TaskModel } from '../lib/TaskBoard/model/TaskModel.js';
// store
export { default as TaskStore } from '../lib/TaskBoard/store/TaskStore.js';
// view/mixins
export { default as ExpandCollapse } from '../lib/TaskBoard/view/mixin/ExpandCollapse.js';
export { default as ResponsiveCards } from '../lib/TaskBoard/view/mixin/ResponsiveCards.js';
export { default as TaskBoardColumns } from '../lib/TaskBoard/view/mixin/TaskBoardColumns.js';
export { default as TaskBoardDom } from '../lib/TaskBoard/view/mixin/TaskBoardDom.js';
export { default as TaskBoardDomEvents } from '../lib/TaskBoard/view/mixin/TaskBoardDomEvents.js';
export { default as TaskBoardScroll } from '../lib/TaskBoard/view/mixin/TaskBoardScroll.js';
export { default as TaskBoardStores } from '../lib/TaskBoard/view/mixin/TaskBoardStores.js';
export { default as TaskBoardSwimlanes } from '../lib/TaskBoard/view/mixin/TaskBoardSwimlanes.js';
export { default as TaskBoardVirtualization } from '../lib/TaskBoard/view/mixin/TaskBoardVirtualization.js';
export { default as TaskItems } from '../lib/TaskBoard/view/mixin/TaskItems.js';
export { default as TaskNavigation } from '../lib/TaskBoard/view/mixin/TaskNavigation.js';
export { default as TaskSelection } from '../lib/TaskBoard/view/mixin/TaskSelection.js';
// view/items
export { default as ImageItem } from '../lib/TaskBoard/view/item/ImageItem.js';
export { default as JsxItem } from '../lib/TaskBoard/view/item/JsxItem.js';
export { default as ProgressItem } from '../lib/TaskBoard/view/item/ProgressItem.js';
export { default as RatingItem } from '../lib/TaskBoard/view/item/RatingItem.js';
export { default as ResourceAvatarsItem } from '../lib/TaskBoard/view/item/ResourceAvatarsItem.js';
export { default as SeparatorItem } from '../lib/TaskBoard/view/item/SeparatorItem.js';
export { default as TagsItem } from '../lib/TaskBoard/view/item/TagsItem.js';
export { default as TaskItem } from '../lib/TaskBoard/view/item/TaskItem.js';
export { default as TemplateItem } from '../lib/TaskBoard/view/item/TemplateItem.js';
export { default as TextItem } from '../lib/TaskBoard/view/item/TextItem.js';
export { default as TodoListItem } from '../lib/TaskBoard/view/item/TodoListItem.js';
// view
export { default as TaskBoard } from '../lib/TaskBoard/view/TaskBoard.js';
export { default as TaskBoardBase } from '../lib/TaskBoard/view/TaskBoardBase.js';
// widget base
export { default as ColorBoxCombo } from '../lib/TaskBoard/widget/base/ColorBoxCombo.js';
// widget mixin
export { default as TaskBoardLinked } from '../lib/TaskBoard/widget/mixin/TaskBoardLinked.js';
export { default as ColumnCombo } from '../lib/TaskBoard/widget/ColumnCombo.js';
export { default as ColumnFilterField } from '../lib/TaskBoard/widget/ColumnFilterField.js';
export { default as ColumnPickerButton } from '../lib/TaskBoard/widget/ColumnPickerButton.js';
export { default as ColumnScrollButton } from '../lib/TaskBoard/widget/ColumnScrollButton.js';
export { default as ProjectCombo } from '../lib/TaskBoard/widget/ProjectCombo.js';
export { default as ResourcesCombo } from '../lib/TaskBoard/widget/ResourcesCombo.js';
export { default as SwimlaneCombo } from '../lib/TaskBoard/widget/SwimlaneCombo.js';
export { default as SwimlaneFilterField } from '../lib/TaskBoard/widget/SwimlaneFilterField.js';
export { default as SwimlanePickerButton } from '../lib/TaskBoard/widget/SwimlanePickerButton.js';
export { default as SwimlaneScrollButton } from '../lib/TaskBoard/widget/SwimlaneScrollButton.js';
export { default as TagCombo } from '../lib/TaskBoard/widget/TagCombo.js';
export { default as TaskColorPicker } from '../lib/TaskBoard/widget/TaskColorPicker.js';
export { default as TaskColorCombo } from '../lib/TaskBoard/widget/TaskColorCombo.js';
export { default as TaskEditor } from '../lib/TaskBoard/widget/TaskEditor.js';
export { default as TaskFilterField } from '../lib/TaskBoard/widget/TaskFilterField.js';
export { default as TodoListField } from '../lib/TaskBoard/widget/TodoListField.js';
export { default as UndoRedo } from '../lib/TaskBoard/widget/UndoRedo.js';
export { default as ZoomSlider } from '../lib/TaskBoard/widget/ZoomSlider.js';
//region Grid (internal)
export { default as GridRowModel } from '../lib/Grid/data/GridRowModel.js';
//endregion
//region Scheduler (internal)
// crud
export { default as AbstractCrudManager } from '../lib/Scheduler/crud/AbstractCrudManager.js';
export { default as AbstractCrudManagerMixin } from '../lib/Scheduler/crud/AbstractCrudManagerMixin.js';
export { default as AbstractCrudManagerValidation } from '../lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js';
export { default as AjaxTransport } from '../lib/Scheduler/crud/transport/AjaxTransport.js';
export { default as JsonEncoder } from '../lib/Scheduler/crud/encoder/JsonEncoder.js';
// crud mixin
export { default as CrudManagerView } from '../lib/Scheduler/crud/mixin/CrudManagerView.js';
// data
export { default as AssignmentStore } from '../lib/Scheduler/data/AssignmentStore.js';
export { default as CrudManager } from '../lib/Scheduler/data/CrudManager.js';
export { default as DependencyStore } from '../lib/Scheduler/data/DependencyStore.js';
export { default as EventStore } from '../lib/Scheduler/data/EventStore.js';
export { default as ResourceStore } from '../lib/Scheduler/data/ResourceStore.js';
export { default as ResourceTimeRangeStore } from '../lib/Scheduler/data/ResourceTimeRangeStore.js';
export { default as TimeRangeStore } from '../lib/Scheduler/data/TimeRangeStore.js';
// model
export { default as AssignmentModel } from '../lib/Scheduler/model/AssignmentModel.js';
export { default as DependencyBaseModel } from '../lib/Scheduler/model/DependencyBaseModel.js';
export { default as DependencyModel } from '../lib/Scheduler/model/DependencyModel.js';
export { default as EventModel } from '../lib/Scheduler/model/EventModel.js';
export { default as RecurrenceModel } from '../lib/Scheduler/model/RecurrenceModel.js';
export { default as ResourceModel } from '../lib/Scheduler/model/ResourceModel.js';
export { default as ResourceTimeRangeModel } from '../lib/Scheduler/model/ResourceTimeRangeModel.js';
export { default as SchedulerProjectModel } from '../lib/Scheduler/model/ProjectModel.js';
export { default as TimeRangeModel } from '../lib/Scheduler/model/TimeRangeModel.js';
export { default as TimeSpan } from '../lib/Scheduler/model/TimeSpan.js';
// model mixin
export { default as AssignmentModelMixin } from '../lib/Scheduler/model/mixin/AssignmentModelMixin.js';
export { default as EventModelMixin } from '../lib/Scheduler/model/mixin/EventModelMixin.js';
export { default as ProjectModelCommon } from '../lib/Scheduler/model/mixin/ProjectModelCommon.js';
export { default as ProjectModelMixin } from '../lib/Scheduler/model/mixin/ProjectModelMixin.js';
export { default as ProjectModelTimeZoneMixin } from '../lib/Scheduler/model/mixin/ProjectModelTimeZoneMixin.js';
export { default as RecurringTimeSpan } from '../lib/Scheduler/model/mixin/RecurringTimeSpan.js';
export { default as ResourceModelMixin } from '../lib/Scheduler/model/mixin/ResourceModelMixin.js';
export { default as TimeZonedDatesMixin } from '../lib/Scheduler/model/mixin/TimeZonedDatesMixin.js';
// data mixin
export { default as AssignmentStoreMixin } from '../lib/Scheduler/data/mixin/AssignmentStoreMixin.js';
export { default as DependencyStoreMixin } from '../lib/Scheduler/data/mixin/DependencyStoreMixin.js';
export { default as EventStoreMixin } from '../lib/Scheduler/data/mixin/EventStoreMixin.js';
export { default as GetEventsMixin } from '../lib/Scheduler/data/mixin/GetEventsMixin.js';
export { default as PartOfProject } from '../lib/Scheduler/data/mixin/PartOfProject.js';
export { default as ProjectCrudManager } from '../lib/Scheduler/data/mixin/ProjectCrudManager.js';
export { default as RecurringEventsMixin } from '../lib/Scheduler/data/mixin/RecurringEventsMixin.js';
export { default as RecurringTimeSpansMixin } from '../lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js';
export { default as ResourceStoreMixin } from '../lib/Scheduler/data/mixin/ResourceStoreMixin.js';
// widget
export { default as SchedulerProjectCombo } from '../lib/Scheduler/widget/ProjectCombo.js';
//endregion


import GlobalEvents from '../lib/Core/GlobalEvents.js';
import BrowserHelper from '../lib/Core/helper/BrowserHelper.js';
import VersionHelper from '../lib/Core/helper/VersionHelper.js';
import Widget from '../lib/Core/widget/Widget.js';
import Toast from '../lib/Core/widget/Toast.js';
import Override from '../lib/Core/mixin/Override.js';
import DomHelper from '../lib/Core/helper/DomHelper.js';
import TaskBoardBase from '../lib/TaskBoard/view/TaskBoardBase.js';
(() => {
    //region Common
    const
        HOSTS            = [
            'bryntum.com',
            'cdpn.io',
            'react-gantt.com',
            'vue-gantt.com',
            'vue-scheduler.com',
            'react-scheduler.com',
            'angular-scheduler.com',
            'angular-calendar.com',
            'vue-calendar.com',
            'react-calendar.com',
            'lmctfy.net'
        ],
        ONE_DAY          = 1000 * 60 * 60 * 24,
        EXPIRING_CLASSES = [];
    if (!VersionHelper.isTestEnv && (HOSTS.some(host => location.host.includes(host)) || /\/docs/.test(location.href))) {
        return;
    }
    let initialized;
    function initExpiryHelper(owner, baseClass) {
        if (!initialized) {
            initialized = true;
            ExpiryHelper.construct({
                widget : owner
            });
        }
        // do not remove this line (used to distinguish trial bundles by regexp)
        owner.__foo = 'THISISTRIAL';
    }
    //endregion
    //region ExpiryHelper
    class ExpiryHelper {
        static construct(config) {
            const
                me            = this,
                product       = 'gantt',
                productName   = 'Gantt',
                version       = VersionHelper.getVersion(product),
                callHomeDelay = VersionHelper.isTestEnv ? 3000 : 1000 * 60,
                blockUrl      = BrowserHelper.queryString.blockUrl;
            Object.assign(me, {
                version,
                product,
                Product          : productName,
                verifyUrl        : VersionHelper.isTestEnv ? blockUrl : 'https://bryntum.com/verify/',
                blocked          : false,
                lastVersionCheck : 0,
                trialKey         : `b-${product}-trial-start`,
                versionCheckKey  : `b-${product}-verify-date`
            }, config);
            if (!VersionHelper.isTestEnv) {
                console.log(`Bryntum ${productName} Trial Version`);
            }
            me.cacheTrialStartTime();
            if (me.isExpired) {
                if (document.readyState === 'complete') {
                    me.onTrialExpired();
                }
                else {
                    document.addEventListener('readystatechange', () => {
                        if (document.readyState === 'complete') {
                            me.onTrialExpired();
                        }
                    });
                }
            }
            // Call home to log trial usage, assuming localStorage access works reliably
            // 1 min delay to be less easily detected
            setTimeout(() => {
                me.updateBlockedStatus();
            }, callHomeDelay);
        }
        static cacheTrialStartTime() {
            const
                me         = this,
                timeString = BrowserHelper.getLocalStorageItem(me.trialKey),
                time       = Number(timeString);
            if (time && !isNaN(time)) {
                me.trialStartTime = time;
            }
            me.trialStartTime = me.trialStartTime || Date.now();
            // First trial access, or no localstorage (no local storage meaning our expiration mechanism won't work. Only remote blocking will end the trial)
            BrowserHelper.setLocalStorageItem(me.trialKey, me.trialStartTime);
        }
        static get isExpired() {
            return this.blocked || (Date.now() - this.trialStartTime > ONE_DAY * 45) || window.bryntum?.[this.product]?.expired;
        }
        static updateBlockedStatus() {
            const
                me                  = this,
                saveVersionCheckKey = () => BrowserHelper.setLocalStorageItem(me.versionCheckKey, Date.now());
            me.lastVersionCheck = me.lastVersionCheck || BrowserHelper.getLocalStorageItem(me.versionCheckKey) || 0;
            // Max 1 version check per session / day
            if (me.lastVersionCheck && Date.now() - me.lastVersionCheck < ONE_DAY) {
                return;
            }
            if (me.verifyUrl) {
                const
                    url    = encodeURIComponent(location.href),
                    logUrl = `${me.verifyUrl}?id=${window.bryntum.license}&url=${url}`,
                    img    = new Image();
                img.onload = () => {
                    // 2x2 image means trial is blocked due to violation
                    if (img.naturalWidth === 2) {
                        me.blockTrial();
                    }
                    else {
                        // Just in case
                        saveVersionCheckKey();
                    }
                };
                img.onerror = () => {
                    saveVersionCheckKey();
                };
                img.src = logUrl;
            }
            else {
                saveVersionCheckKey();
            }
        }
        static onTrialExpired() {
            const rootEl = this.widget.rootElement;
            if (!this.expirationShown) {
                this.expirationShown = true;
                if (!VersionHelper.isTestEnv) {
                    console.warn(`Bryntum ${this.Product} trial version expired. Purchase a license at https://bryntum.com/store or contact us at https://bryntum.com/contact/ for licensing options.`);
                }
                rootEl.floatRoot && Toast.show({
                    html        : `Psst! Your Bryntum ${this.Product} trial has expired. Please see <a href="https://bryntum.com/store">our store</a> for licensing options`,
                    timeout     : 20000,
                    rootElement : rootEl
                });
            }
            DomHelper.removeEachSelector(rootEl, '.b-sch-dependency');
            DomHelper.forEachSelector(rootEl, '.b-container', element => {
                const widget = Widget.fromElement(element, 'widget');
                if (EXPIRING_CLASSES.some(cls => widget instanceof cls)) {
                    this.maskExpiredWidget(widget);
                }
            });
        }
        static blockTrial() {
            this.blocked = true;
            // Get rid of version check timestamp
            BrowserHelper.removeLocalStorageItem(this.versionCheckKey);
            // To force expired state: Set a fake early trial timestamp
            BrowserHelper.setLocalStorageItem(this.trialKey, 1);
            this.onTrialExpired();
        }
        static maskExpiredWidget(widget) {
            widget.mask({
                text  : '<h3 style="margin:0">Trial expired, <a href="https://bryntum.com/store" style="margin:0 3px; color:inherit">click here</a> to buy a license.</h3>',
                icon  : 'b-fa b-fa-frown',
                type  : 'trial',
                cover : 'target'
            });
        }
        static setWaterMark(element, {
            darkColor = 'rgba(255, 255, 255, 0.03)',
            lightColor = 'rgba(240, 240, 240, 0.54)'
        } = {}) {
            // Used for thumbnails
            if (BrowserHelper.queryString.thumb != null) {
                return;
            }
            const
                color     = DomHelper.themeInfo?.name?.toLowerCase().endsWith('-dark') ? darkColor : lightColor,
                svgString = `
                   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" style="font-family:sans-serif;font-weight:900;fill:${color}">
                    <defs>
                        <pattern id="company" patternUnits="userSpaceOnUse" width="400" height="200">
                            <text y="30" font-size="40" id="name">Bryntum</text>
                            <text y="120" x="200" font-size="24" id="trial">Trial Version</text>
                        </pattern>
                        <pattern id="pattern" xlink:href="#company" patternTransform="rotate(-45)">
                            <use xlink:href="#name" /><use xlink:href="#trial" />
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#pattern)" />
                </svg>`;
            element.style.backgroundImage = `url('data:image/svg+xml;base64,${window.btoa(svgString)}')`;
        };
    }
    //endregion
    //region Common override
    const applyBaseOverride = baseClass => {
        EXPIRING_CLASSES.push(baseClass);
        Override.apply(class {
            static get target() {
                return {
                    class : baseClass
                };
            }
            onPaintOverride() {
                const
                    me            = this,
                    setWatermarks = () => {
                        const targets = me.subGrids ? Object.values(me.subGrids) : [me];
                        for (const target of targets) {
                            if (target.element) {
                                ExpiryHelper.setWaterMark(target.element);
                            }
                        }
                    };
                initExpiryHelper(me, baseClass);
                setWatermarks();
                // React to theme changes
                GlobalEvents.on('theme', () => {
                    setWatermarks();
                });
                if (ExpiryHelper.isExpired) {
                    ExpiryHelper.maskExpiredWidget(me);
                }
            }
        });
    };
    //endregion
    if (typeof TaskBoardBase !== 'undefined') {
        EXPIRING_CLASSES.push(TaskBoardBase);
        const watermarkTaskBoardBase = taskboard => {
            const
                { element }  = taskboard,
                setWatermark = selector => [...element.querySelectorAll(selector)]
                    .forEach(el =>
                        ExpiryHelper.setWaterMark(el, { lightColor : 'rgba(220, 220, 220, 0.54)' }
                        ));
            setWatermark('.b-taskboard-column-body');
        };
        Override.apply(class {
            static get target() {
                return {
                    class : TaskBoardBase
                };
            }
            renderCard() {
                if (!ExpiryHelper.isExpired) {
                    return this._overridden.renderCard.apply(this, arguments);
                }
            }
            onRenderColumn() {
                this._overridden.onRenderColumn.apply(this, arguments);
                watermarkTaskBoardBase(this);
            }
            onPaintOverride() {
                initExpiryHelper(this, TaskBoardBase);
                // React to theme changes
                GlobalEvents.on('theme', () => {
                    watermarkTaskBoardBase(this);
                });
                if (ExpiryHelper.isExpired) {
                    ExpiryHelper.maskExpiredWidget(this);
                }
            }
        });
    }
})();
(() => {
    // do not load analytics code for specific domains
    const ignoreDomainRe = /(.force.com|.lightning.com|.salesforce.com|lmctfy.net|qa.bryntum.com|qa2.bryntum.com)/;
    // document location might be null in firefox in salesforce
    if (!document.location || ignoreDomainRe.test(document.location.href) || window.top !== window) {
        return;
    }
    let id;
    const websiteUrls = [
        'bryntum.com',
        'cdpn.io'
    ];
    const
        products   = ['calendar', 'grid', 'gantt', 'scheduler', 'schedulerpro', 'taskboard'],
        frameworks = ['angular', 'react', 'vue', 'ionic'];
    websiteUrls.splice(0, 0, ...products.map(prod => frameworks.map(framework => `${framework}-${prod}`)).concat('bryntum.com').flat());
    if (document.location.host.match(websiteUrls.join('|'))) {
        id = 'G-1VY6776VJP';
    }
    else {
        id = 'G-H465KZDH8S';
    }
    const newScript = document.createElement('script');
    newScript.onload = function() {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', id);
    };
    document.head.appendChild(newScript);
    newScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
})();
